import styled from 'styled-components'

export const HeaderContainer = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  margin-top: 1rem;
  margin-bottom: 1rem;
  padding: 0.25rem;
`
export const HeaderScrollTextContainer = styled.span`
  position: absolute;
  right: 0;
  bottom: -2rem;
  padding: 0.25rem;
  font-size: 80%;
  color: ${(props) => props.theme.colors.gray};
`

export const InstrumentScreenContent = styled.div`
  display: flex;
  flex-direction: column;
  align-content: center;
  padding-bottom: 10px;
  width: 90%;
  margin-bottom: 1rem;

  .text-center,
  h6 {
    font-weight: 500;
    font-size: 14pt;
    text-align: center;
    padding-top: 5px;
    padding-bottom: 3px;
  }

  p {
    font-size: 14pt;
    margin-bottom: 3px;
  }
`

export const FooterScrollTextContainer = styled.span`
  position: absolute;
  top: -2rem;
  right: 0;
  padding: 0.25rem;
  font-size: 80%;
  color: ${(props) => props.theme.colors.gray};
`

export const FormQuestions = styled.div`
  align-content: center;
  justify-content: start;
  padding-top: 0.25rem;
`

export const ScreenHeader = styled.div`
  text-align: center;
  color: ${(props) => props.theme.colors.primary};
  font-size: 14pt;
  font-weight: 500;

  ul {
    text-align: left;
    list-style-type: circle;
  }
`

export const FooterRow = styled.div`
  display: flex;
  width: 100%;
  position: sticky;
  bottom: 0;
  z-index: 10;
  background-color: white;
  border-radius: 25px;
  padding: 1rem 0;
`

export const ScreenContent = styled.div`
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  justify-content: center;
  padding-bottom: 5rem;

  .text-center {
    font-weight: 500;
    font-size: 14pt;
    text-align: center;
    padding-top: 5px;
    padding-bottom: 3px;
  }

  h6 {
    font-weight: 500;
    font-size: 14pt;
    text-align: center;
    padding-top: 5px;
    padding-bottom: 3px;
  }

  p {
    margin-bottom: 6px;
  }

  ol {
    list-style-type: decimal;
    margin-left: 2.5rem;

    li {
      margin-bottom: 1rem;
    }
  }
`
